import * as actionTypes from '@store/actions/actionTypes';

const initialState = {
  loading: false,
  loaded: false,
  list: [],
  limit: 10,
  page: 1,
  total: 0,
  start: 0,
  end: 0,
  viewItem: {},
  sort: 'name',
  direction: 'ASC'
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LENDERS_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.LENDERS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case actionTypes.LENDERS_FAIL:
      return {
        ...state,
        loading: false
      };
    default:
      return state;
  }
};

export default reducer;
